<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title
        :title="$t('message.aside.geofencing', { value: 'default' })"
      ></portal-title>
      <portal-breadcumb></portal-breadcumb>

      <div class="content">
        <v-row class="fixed">
          <v-col class="d-flex" cols="12" sm="2">
            <v-autocomplete
              :items="assetList"
              :label="$t('message.pageKm.loco', { value: 'default' })"
              item-value="assetnum"
              item-text="assetnum"
              hide-details="auto"
              multiple
              outlined
              dense
              v-model="assets"
              @change="filterGroupByAsset"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.assetnum }}</span>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ assets.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col class="d-flex" cols="12" sm="3">
            <v-autocomplete
              :items="countriesList"
              :label="$t('message.geofencing.select', { value: 'default' })"
              hide-details="auto"
              multiple
              outlined
              v-model="countries"
              dense
              disabled
              @change="filterGroupByCountry"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item }}</span>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ countries.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <portal-loading :show="showPoiCountry"></portal-loading>
        <portal-timeline
          class="pt-16"
          :filter="filter"
          :items="items"
          :buildItem="handleRangechanged"
          :handleRangechanged="handleRangechanged"
        ></portal-timeline>
      </div>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import PortalTimeline from "@/components/PortalTimeline";
import { mapActions, mapGetters } from "vuex";
import CascService from "@/services/CascService";
import PortalLoading from "@/components/PortalLoading.vue";
import {
  currentDateTime,
} from "@/shared/DateHelper";
export default {
  methods: {
    ...mapActions("carpet", {
      actionGetAssets: "loadAssets",
    }),
   
    initAssetList() {
      this.assetList = this.getterAssets;
    },

    //filter By Asset
    filterGroupByAsset() {
      this.filter = this.assets;
    },

    //filter By Country
    filterGroupByCountry() {
      let list = this.countries;
      if (list.length > 0) {
        this.filterPoisCountry(list);
      } else {
        this.items = this.poisCountries;
      }
    },

    async getPoiCountry(){
      this.showPoiCountry = true;
      this.poisCountries=[];
      let locos = this.getterAssets.map(a => a.asset);
      let payload = {locomotives: locos}
      await CascService.findLocoPoiByCountry(payload).then(response => {
        let i = 0;
        let data = [];
        let dataLength = response.data.length;

        //if enter and exit from different countries at the same time ensure that exit comes before enter
        while(i < dataLength - 1){
          if(response.data[i].__time == response.data[i+1].__time 
            && response.data[i].locomotive == response.data[i+1].locomotive 
            && response.data[i].action == "enter" && response.data[i+1].action == "exit"){
              [response.data[i], response.data[i+1]] = [response.data[i+1], response.data[i]];
            }
            i+=1;
        }
        
        // should always begin with an entry to workshop
        while (response.data[0] && response.data[0].action != "enter") {
          response.data.splice(0, 1);
        }

        i=0;

        while(i < dataLength - 1){
          // valid data : entry then exit of a loco 
          if( response.data[i].action == "enter" && response.data[i+1].action == "exit" 
          && Date.parse(response.data[i].__time) < Date.parse(response.data[i+1].__time) 
          && response.data[i].locomotive == response.data[i+1].locomotive){
            data.push(response.data[i]);
            data.push(response.data[i+1]);
            i+=2;
          }
          else if( i < dataLength - 1){
            // we expect entry first so delete exit data
            if( response.data[i].action == "exit"){
              response.data.splice(i, 1);
            }
            // successive entries of same loco : we delete second
            else if(response.data[i].action == "enter" && response.data[i+1].action == "enter" 
            && response.data[i].locomotive == response.data[i+1].locomotive){
              response.data.splice(i+1, 1);
            }
            // successive entries with different locos : we add exit at today date for the first
            else if(response.data[i].action == "enter" && response.data[i+1].action == "enter" 
            && response.data[i].locomotive != response.data[i+1].locomotive){
              response.data.splice(i+1, 0, { locomotive: response.data[i].locomotive,
                action: "exit", country: response.data[i].country, type: "fictive", __time: currentDateTime(),
              });
            }
            // successive entry and exit with different locos : we add exit at today date for the first
            else if(response.data[i].action == "enter" && response.data[i+1].action == "exit" 
            && response.data[i].locomotive != response.data[i+1].locomotive){
              response.data.splice(i+1, 0, { locomotive: response.data[i].locomotive,
                action: "exit", country: response.data[i].country, type: "fictive", __time: currentDateTime(),
              });
            }
            // unknown cases we continue
            else{
               i+=2;
            }
          }
        dataLength = response.data.length;

        }
        for (i = 0; i < data.length - 1; i+=2) {
          this.poisCountries.push({
            id: "POI_COUNTRY"+i,
            end: data[i+1].type == "fictive" ? currentDateTime() : data[i+1].__time.substring(0,data[i+1].__time.length-1)+"+00:00",
            start: data[i].__time.substring(0,data[i].__time.length-1)+"+00:00",
            group: data[i].locomotive,
            className: "poi",
            country: data[i].country,
            subgroup: "int",
            subgroupOrder: 1,
            ended: data[i+1].type !== "fictive",
        });
          
      }
      // feature has requested only germany geoffencing for the moment
      this.items = this.poisCountries.filter(function (item) { 
          return item.country == "Germany";
        });
      // uncomment this line when filter will be extended to all possible values of geoffencing countries
      //this.countriesList = [...new Set(this.poisCountries.map(poi => poi.country))];
      this.showPoiCountry = false;
      return data;

      });
    },

    filterPoisCountry(countries){
      this.items = this.poisCountries.filter(function (item) { 
        return countries.find(country => item.country == country);
      });
    },

    async buildItems() {
      await this.getPoiCountry();
    },

    handleRangechanged(){
      // no specific overriding
    }
  },
  name: "GeofencingPage",
  title: "My MINT",

  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    PortalTimeline,
    PortalLoading,
  },
  data() {
    return {
      filter: [],
      message: "",
      countries: ['Germany'],
      countriesList: ['Germany'],
      assets: [],
      assetList: [],
      items: [],
      poisCountries: [],
      showPoiCountry: false,
    };
  },

  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterContact: "getUserContact",
    }),

    ...mapGetters("carpet", {
      getterAssets: "getAssets",
    }),
  },
  mounted() {
    this.initAssetList();
    this.buildItems();
  },
};
</script>

<style scoped>

:deep(.vis-item.poi) {
  background: #fbde85;
  border: #fbde85;
}

:deep(.vis-group){
  background-color: #fff;
}

</style>
